const ADMIN_ORDER_API_ROOT = '/admin/order';
const ADMIN_MANY_ORDERS_API_ROOT = '/admin/orders';

export const ADMIN_ORDER_API_PATHS = {
  CREATE: `${ADMIN_ORDER_API_ROOT}`,
  ARCHIVE_BY_ID: `${ADMIN_ORDER_API_ROOT}/archive`,
  GET_ORDER_LABELS: (orderId) => `${ADMIN_ORDER_API_ROOT}/${orderId}/labels`,
  GET_ORDER_BY_ID: (orderId) => `${ADMIN_ORDER_API_ROOT}/${orderId}`,
  UPDATE: (orderId) => `${ADMIN_ORDER_API_ROOT}/${orderId}`,
};

export const ADMIN_MANY_ORDERS_API_PATHS = {
  GET_ORDERS: `${ADMIN_MANY_ORDERS_API_ROOT}`,
  GET_LABELS_BY_DATE: `${ADMIN_MANY_ORDERS_API_ROOT}/labels/:deliveryDate`,
  GET_LAST_USER_ORDERS: `${ADMIN_MANY_ORDERS_API_ROOT}/last-user-orders/:userId`,
  TO_ARCHIVE: `${ADMIN_MANY_ORDERS_API_ROOT}/to-archive`,
  ARCHIVE: `${ADMIN_MANY_ORDERS_API_ROOT}/archive`,
  UNARCHIVE: `${ADMIN_MANY_ORDERS_API_ROOT}/unarchive`,
  GET_DELIVERY_NOTES: `${ADMIN_MANY_ORDERS_API_ROOT}/delivery/notes/:deliveryDate`,
  GET_ORDERS_DELIVERY_NOTES: `${ADMIN_MANY_ORDERS_API_ROOT}/delivery-notes`,
  GET_ORDERS_DELIVERY_NOTES_CSV: `${ADMIN_MANY_ORDERS_API_ROOT}/delivery-notes/csv`,
  DOWNLOAD_ORDERS_LIST_XLSX: `${ADMIN_MANY_ORDERS_API_ROOT}/delivery/notes/download/:deliveryDate`,
};
